import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="kredit-zinsbindung-zins"
export default class extends Controller {
	static targets = ["zins", "prolongationszins"]

	connect() {
		if (!this.hasZinsTarget || !this.hasProlongationszinsTarget) return
		if (this.prolongationszinsTarget.value.trim() !== "") return

		this.syncProlongationszins()
	}

	syncProlongationszins() {
		if (!this.hasZinsTarget || !this.hasProlongationszinsTarget) return

		this.prolongationszinsTarget.value = this.zinsTarget.value
		this.prolongationszinsTarget.dispatchEvent(new Event("change", { bubbles: true, cancelable: true }))
	}

	ensureProlongationszinsPresent({ currentTarget }) {
		if (!this.hasZinsTarget) return
		if (currentTarget.value.trim() !== "" && currentTarget.value !== "NaN") return

		currentTarget.value = this.zinsTarget.value
		currentTarget.dispatchEvent(new Event("change", { bubbles: true, cancelable: true }))
	}
}
